export const housingConstants = {
    SET_PARAMS_REQUEST: 'HOUSINGS_SET_PARAMS_REQUEST',

    GETALL_REQUEST: 'HOUSINGS_GETALL_REQUEST',
    GETALL_SUCCESS: 'HOUSINGS_GETALL_SUCCESS',
    GETALL_FAILURE: 'HOUSINGS_GETALL_FAILURE',

    DELETE_REQUEST: 'HOUSINGS_DELETE_REQUEST',
    DELETE_SUCCESS: 'HOUSINGS_DELETE_SUCCESS',
    DELETE_FAILURE: 'HOUSINGS_DELETE_FAILURE',

    GET_REQUEST: 'HOUSINGS_GET_REQUEST',
    GET_SUCCESS: 'HOUSINGS_GET_SUCCESS',
    GET_FAILURE: 'HOUSINGS_GET_FAILURE',

    ADD_REQUEST: 'HOUSINGS_ADD_REQUEST',
    ADD_SUCCESS: 'HOUSINGS_ADD_SUCCESS',
    ADD_FAILURE: 'HOUSINGS_ADD_FAILURE',

    UPDATE_REQUEST: 'HOUSINGS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'HOUSINGS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'HOUSINGS_UPDATE_FAILURE',

    UPDATE_FIELD_REQUEST: 'HOUSINGS_UPDATE_FIELD_REQUEST',
    UPDATE_FIELD_SUCCESS: 'HOUSINGS_UPDATE_FIELD_SUCCESS',
    UPDATE_FIELD_FAILURE: 'HOUSINGS_UPDATE_FIELD_FAILURE',
}